import { createApp } from 'vue';
import App from './App';
import Emitter from '../plugins/emitter';
import helpers from '../utils/helper';

const app = createApp(App);
app.use(Emitter);
app.mixin(helpers);
app.mount('#public_dashboard');